module.exports = __webpack_public_path__ + "img/fruct23_demo.fbb49f5c.jpg";